import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"
import {
    Dialog,
    DialogTitle,
    DialogContent,
  } from "@material-ui/core";
import { TraerTrackingFacturacion } from "../../../../actions/compras/TrackingSolicitudCotizacion";
import { TablaHistorial } from "../../TrackingCotizaciones/TablaHistorial";

export const ModalTrackingFacturacion = (props) => {
    const dispatch = useDispatch();
    const { trackingFacturacionCompras } = useSelector((state) => state.compras);

    useEffect(() => {
        dispatch(TraerTrackingFacturacion(props.comprobante.idTramitesCompras));
    }, [props.open])
console.log(props.comprobante)
    return (
        <Dialog
            fullWidth
            maxWidth='md'
            open={props.open}
            onClose={props.closeModalHandler}
        >
            <DialogTitle>Historial de Cambios </DialogTitle>
            <DialogContent>
                <TablaHistorial datos={trackingFacturacionCompras}/>
            </DialogContent>
        </Dialog>

    )
}